import { render, staticRenderFns } from "./TheAvatarScreen.vue?vue&type=template&id=1411690b&"
import script from "./TheAvatarScreen.vue?vue&type=script&lang=js&"
export * from "./TheAvatarScreen.vue?vue&type=script&lang=js&"
import style0 from "./TheAvatarScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports